module.exports = __webpack_public_path__ + "media/2.ae8a06b2.mp3";